let baseURL;
let baseURL2;
switch (process.env.NODE_ENV) {
    //生产环境
    case 'development':
        baseURL = '/api1';
        baseURL2 = '/api2';
        break;
    //正式环境
    case 'production':
        baseURL = 'http://ipdata.cc/api';
        baseURL2 = 'http://ipdata.cc/api';
        // baseURL2 = '/api2';
        break;
}

export default {
    baseURL,baseURL2
}
